// In-app reminders (2026-10-04): a pop-up that appears from a due date until it is dismissed or snoozed.
// State is kept per browser in localStorage ({id: {dismissed, snoozeUntil}}); a reminder never nags before its due date.
// Pure functions, tested by frontend/tests/reminders.test.mjs. Dates are the viewer's LOCAL calendar days.

export const REMINDERS = [
  {
    id: 'choose-design-2026-10-06',
    due: '2026-10-06',   // Tuesday
    title: 'Choose your dashboard version',
    body: 'You asked to be reminded: you have been trying ORIG, V1, V2, V3 and V4. Open your notes, then keep one so the others can be removed.',
    choices: ['orig', 'v1', 'v2', 'v3', 'v4'],
  },
]

const KEY = 'sf_reminders'

// Start of the given local calendar day, e.g. '2026-10-06' -> Date at 00:00 in the viewer's time zone.
export function dayStart(ymd) {
  const [y, m, d] = String(ymd).split('-').map(Number)
  return new Date(y, m - 1, d, 0, 0, 0, 0)
}

export function nextDayStart(now) {
  return new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0)
}

export function readState(storage) {
  try { return JSON.parse((storage || window.localStorage).getItem(KEY) || '{}') || {} } catch { return {} }
}

export function writeState(state, storage) {
  try { (storage || window.localStorage).setItem(KEY, JSON.stringify(state)) } catch { /* the reminder simply shows again next visit */ }
}

// Reminders to show now: due (the local day has started), not dismissed, not snoozed past now. Earliest due first.
export function dueReminders(now = new Date(), state = {}, reminders = REMINDERS) {
  return reminders
    .filter(r => now >= dayStart(r.due))
    .filter(r => {
      const s = state[r.id] || {}
      if (s.dismissed) return false
      if (s.snoozeUntil && now < new Date(s.snoozeUntil)) return false
      return true
    })
    .sort((a, b) => a.due.localeCompare(b.due))
}

export function dismiss(state, id) {
  return { ...state, [id]: { ...(state[id] || {}), dismissed: true } }
}

export function snoozeUntilTomorrow(state, id, now = new Date()) {
  return { ...state, [id]: { ...(state[id] || {}), snoozeUntil: nextDayStart(now).toISOString() } }
}
